/**
 * Охват извлечения и «данные с <даты>» над блоками вопросов клиентов и
 * причин отказа (#843, #844): знаменатель называется до числителей.
 */
import { useTranslation } from 'react-i18next';
import type { VoiceCustomerQuestions } from '@aica/api-types/schemas';
import { formatDateShort } from '@/lib/utils';
import { coverageLines } from './voice-questions-view-model';

/** Охват и история — над блоками, до чисел. */
export function VoiceQuestionsCoverage({ cq }: { cq: VoiceCustomerQuestions }) {
  const { t } = useTranslation('dashboard');
  return (
    <div
      className="space-y-1 text-xs text-fg-muted"
      data-testid="voice-questions-coverage"
    >
      {coverageLines(cq, t, formatDateShort).map((line) => (
        <p key={line}>{line}</p>
      ))}
    </div>
  );
}
